import { generateHash } from '../logging/hash-generator';
import { getCookie, saveCookie } from '../cookie/cookie-utils';
var sessionIdKey = 'sessionId';
export function sessionIdHeader() {
    var sessionId = getSessionId();
    if (!sessionId) {
        sessionId = generateHash();
        saveSessionId(sessionId);
    }
    return {
        sessionId: sessionId,
    };
}
function getSessionId() {
    try {
        return sessionStorage.getItem(sessionIdKey);
    }
    catch (_a) {
        return getCookie(sessionIdKey);
    }
}
function saveSessionId(sessionId) {
    try {
        sessionStorage.setItem(sessionIdKey, sessionId);
    }
    catch (_a) {
        // If session storage is not supported, fallback to saving a cookie, lasting for 10 minutes
        var date = new Date();
        date.setMinutes(date.getMinutes() + 10);
        saveCookie(sessionIdKey, sessionId, date);
    }
}
